import axios from "axios";
import "./stations-form.css";
import "../../shared/station-map-select.css";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import StationMapSelect from "../../shared/station-map-select";

function StationsForm({ onDepartureSelect, selectedCode: selectedCodeFromParent = "" }) {
  const [tHome] = useTranslation("homePage");
  const [stationText, setStationText] = useState("");
  const [optionsView, setOptionsView] = useState("");
  const [stations, setStations] = useState([]);
  const formRef = useRef(null);

  const { register, setValue } = useForm();

  let currentLng = "es";

  useEffect(() => {
    if (localStorage.getItem("lng")) {
      currentLng = localStorage.getItem("lng");
    }
    getStations();
  }, []);

  useEffect(() => {
    if (!selectedCodeFromParent || !stations.length) {
      return;
    }
    const s = stations.find((x) => x.code_text === selectedCodeFromParent);
    if (s) {
      setStationText(`${s.name} (${s.code_text.substring(0, 3)})`);
    }
  }, [selectedCodeFromParent, stations]);

  useEffect(() => {
    if (!optionsView) return undefined;

    const handleClickOutside = (event) => {
      if (formRef.current && !formRef.current.contains(event.target)) {
        setOptionsView("");
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setOptionsView("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [optionsView]);

  const getStations = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/stations?lng=${currentLng}`,
        {
          headers: {
            authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );
      const orderStations = response.data.stations;
      orderStations.sort((a, b) => {
        const isMEXA = a.code_text.startsWith("MEX");
        const isMEXB = b.code_text.startsWith("MEX");

        const isEdoMexA = a.name.toLowerCase().startsWith("edomex");
        const isEdoMexB = b.name.toLowerCase().startsWith("edomex");

        if (isMEXA && !isMEXB) return -1;
        if (!isMEXA && isMEXB) return 1;

        if (isMEXA && isMEXB) {
          if (isEdoMexA && !isEdoMexB) return 1;
          if (!isEdoMexA && isEdoMexB) return -1;

          const numA = parseInt(a.code_text.substring(3), 10);
          const numB = parseInt(b.code_text.substring(3), 10);
          return numA - numB;
        }

        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;

        return 0;
      });

      setStations(orderStations);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeparture = (city) => {
    setOptionsView("");
    setStationText(`${city.name} (${city.code_text.substring(0, 3)})`);
    setValue("departure", city.code_text);
    onDepartureSelect(city.code_text);
  };

  const stationOptions = stations.map((city) => ({
    value: city.code_text,
    label: `${city.name} (${city.code_text.substring(0, 3)})`,
    data: city,
  }));

  return (
    <form>
      <input type="hidden" {...register("departure", { required: true })} />
      <div
        className={`quote-form-station station-map-select-group ${optionsView ? "has-open-dropdown" : ""}`}
        ref={formRef}
      >
        <StationMapSelect
          id="departure"
          placeholder={tHome("quote-shipping-form.select-dep-opt")}
          displayValue={stationText}
          isOpen={optionsView === "mex-stations"}
          onToggle={() =>
            setOptionsView((current) =>
              current === "mex-stations" ? "" : "mex-stations"
            )
          }
          options={stationOptions}
          onSelect={(option) => handleDeparture(option.data)}
          fieldClass="inpt-single"
          ariaLabel={tHome("quote-shipping-form.select-dep-opt")}
        />
      </div>
    </form>
  );
}

export default StationsForm;
